module.exports = __webpack_public_path__ + "img/icon_Applet@2x.12ceeb44.png";